module.exports = __webpack_public_path__ + "img/auntbettys-thumb.533580d4.jpg";